module.exports = __webpack_public_path__ + "img/icon-warning-icing-4.c9cad15e.svg";